import { ApplicationState } from '../../../../store/types';
import { getRolesRoot } from '../../store/selectors';
import { Role } from './types';

export const getRoleModalOpen = (state: ApplicationState): boolean => getRolesRoot(state).roleModalOpen;
export const getDeleteConfirmationDialogOpen = (state: ApplicationState): boolean => getRolesRoot(state).deleteConfirmationDialogOpen;

export const getAllRoles = (state: ApplicationState): Role[] => getRolesRoot(state).allRoles;
export const getSelectedRole = (state: ApplicationState): Role => getRolesRoot(state).selectedRole;
export const getSavedSelectedRole = (state: ApplicationState): Role => getRolesRoot(state).savedSelectedRole;

export const getFetchingRoles = (state: ApplicationState): boolean => getRolesRoot(state).fetchingRoles;
export const getDeletingRole = (state: ApplicationState): boolean => getRolesRoot(state).deletingRole;
